import vectorimage from "../../assets/svg/Vector.svg";
import vectorblackimage from "../../assets/svg/vectorblack.svg";
import DMSLogoimage from "../../assets/svg/DMSLogo.svg";
import TMSLogoimage from "../../assets/svg/TMSLogo.svg";
import GALogoimage from "../../assets/svg/GALogo.svg";
import MenuIconimage from "../../assets/svg/collapse-menu.svg";
import UserIconimage from "../../assets/svg/users.svg";
import UserIconActiveimage from "../../assets/svg/usersactive.svg";
import AppIconimage from "../../assets/svg/application.svg";
import AppIconActiveimage from "../../assets/svg/applicationactivesvg.svg";
import FujitecLogoimage from "../../assets/svg/Fujitec.svg";
import notifyimage from "../../assets/svg/notify.svg";
import logoutimageimage from "../../assets/svg/Logout.svg";
import FailedIconimage from "../../assets/svg/failedred.svg";
import MasterDataIconimage from "../../assets/svg/masterdata.svg";
import MasterDataActiveIconimage from "../../assets/svg/masterDataActive.svg";
import DivisionCodeimage from "../../assets/svg/division.svg";
import DivisionCodeActiveIconimage from "../../assets/svg/divisionActive.svg";
import Departmentimage from "../../assets/svg/department.svg";
import DepartmentActiveIconimage from "../../assets/svg/departmentActive.svg";
import CategoryCodeimage from "../../assets/svg/category.svg";
import CategoryActiveIconimage from "../../assets/svg/categoryActive.svg";
import LevelIconimage from "../../assets/svg/level.svg";
import LevelActiveIconimage from "../../assets/svg/levelActive.svg";
import Designationimage from "../../assets/svg/designation.svg";
import DesignActiveIconimage from "../../assets/svg/designationActive.svg";
import ArrowUpimage from "../../assets/svg/arrow-up.svg";
import ArrowDownimage from "../../assets/svg/arrow-down.svg";
import excelimage from "../../assets/svg/excel.svg";
import excelImportimage from "../../assets/svg/excel-import.svg";
import importHeadimage from "../../assets/svg/import-head.svg";
import reseticonimage from "../../assets/svg/reseticon.svg";
import EmailIconimage from "../../assets/svg/mail.svg";
import PhoneIconimage from "../../assets/svg/phone.svg";
import ManagerIconimage from "../../assets/svg/manager.svg";
import ManagerDropIconimage from "../../assets/svg/managerdrop.svg";
import RequiredIconimage from "../../assets/svg/required.svg";
import LastLoginimage from "../../assets/svg/lastlogin.svg";
import EditIconRedimage from "../../assets/svg/edit-red.svg";
import TickIconimage from "../../assets/svg/checkmark.svg";
import crossWhiteimage from "../../assets/svg/crosswhite.svg";
import FailIconimage from "../../assets/svg/failedsave.svg";
import SortIconimage from "../../assets/svg/sorting.svg";
import Searchimage from "../../assets/svg/search.svg";
import NotifyIconBlackimage from "../../assets/svg/notify-black.svg";
import SaveIconimage from "../../assets/svg/save.svg";
import ApplicationRoleIconimage from "../../assets/svg/application-roles.svg";
import adduserimage from "../../assets/svg/adduser.svg";
import deleteuserimage from "../../assets/svg/deleteuser.svg";
import filterimage from "../../assets/svg/filter.svg";
import arrowrightimage from "../../assets/svg/arrow-right.svg";
import arrowleftimage from "../../assets/svg/arrow-left.svg";
import crossiconimage from "../../assets/svg/cross-close.svg";
import addapplicationimage from "../../assets/svg/addapplication.svg";
import applicationname1image from "../../assets/svg/applicationname1.svg";
import applicationurlimage from "../../assets/svg/applicationurl.svg";
import applicationdescriptionimage from "../../assets/svg/applicationdescription.svg";
import rolesimage from "../../assets/svg/roles.svg";
import editiconredimage from "../../assets/svg/editiconred.svg";
import saveapplicationimage from "../../assets/svg/saveapplication.svg";
import applicationcrossiconimage from "../../assets/svg/applicationcrossicon.svg";
import searchapplicationimage from "../../assets/svg/searchapplication.svg";
import applicationdeleteimage from "../../assets/svg/applicationdelete.svg";
import plusredimage from "../../assets/svg/plusred.svg";
import DeleteIconimage from "../../assets/svg/deleteicon.svg";
import AddMasterimage from "../../assets/svg/addMaster.svg";
import DeleteMasterimage from "../../assets/svg/deleteMaster.svg";
import calendardateimage from "../../assets/svg/calendar-inside.svg"

export const vector = vectorimage;
export const vectorblack = vectorblackimage;
export const DMSLogo = DMSLogoimage;
export const TMSLogo = TMSLogoimage;
export const GALogo = GALogoimage;
export const MenuIcon = MenuIconimage;
export const UserIcon = UserIconimage;
export const UserIconActive = UserIconActiveimage;
export const AppIcon = AppIconimage;
export const AppIconActive = AppIconActiveimage;
export const FujitecLogo = FujitecLogoimage;
export const notify = notifyimage;
export const logoutimage = logoutimageimage;
export const FailedIcon = FailedIconimage;
export const MasterDataIcon = MasterDataIconimage;
export const MasterDataActiveIcon = MasterDataActiveIconimage;
export const DivisionCode = DivisionCodeimage;
export const DivisionCodeActiveIcon = DivisionCodeActiveIconimage;
export const Department = Departmentimage;
export const DepartmentActiveIcon = DepartmentActiveIconimage;
export const CategoryCode = CategoryCodeimage;
export const CategoryActiveIcon = CategoryActiveIconimage;
export const LevelIcon = LevelIconimage;
export const LevelActiveIcon = LevelActiveIconimage;
export const Designation = Designationimage;
export const DesignActiveIcon = DesignActiveIconimage;
export const ArrowUp = ArrowUpimage;
export const ArrowDown = ArrowDownimage;
export const excel = excelimage;
export const excelImport = excelImportimage;
export const importHead = importHeadimage;
export const reseticon = reseticonimage;
export const EmailIcon = EmailIconimage;
export const PhoneIcon = PhoneIconimage;
export const ManagerIcon = ManagerIconimage;
export const ManagerDropIcon = ManagerDropIconimage;
export const RequiredIcon = RequiredIconimage;
export const LastLogin = LastLoginimage;
export const EditIconRed = EditIconRedimage;
export const TickIcon = TickIconimage;
export const crossWhite = crossWhiteimage;
export const FailIcon = FailIconimage;
export const SortIcon = SortIconimage;
export const Search = Searchimage;
export const NotifyIconBlack = NotifyIconBlackimage;
export const SaveIcon = SaveIconimage;
export const ApplicationRoleIcon = ApplicationRoleIconimage;
export const adduser = adduserimage;
export const deleteuser = deleteuserimage;
export const filter = filterimage;
export const arrowright = arrowrightimage;
export const arrowleft = arrowleftimage;
export const crossicon = crossiconimage;
export const addapplication = addapplicationimage;
export const applicationname1 = applicationname1image;
export const applicationurl = applicationurlimage;
export const applicationdescription = applicationdescriptionimage;
export const roles = rolesimage;
export const editiconred = editiconredimage;
export const saveapplication = saveapplicationimage;
export const applicationcrossicon = applicationcrossiconimage;
export const searchapplication = searchapplicationimage;
export const applicationdelete = applicationdeleteimage;
export const plusred = plusredimage;
export const DeleteIcon = DeleteIconimage;
export const AddMaster = AddMasterimage;
export const DeleteMaster = DeleteMasterimage;
export const calendardate = calendardateimage;
